import React from "react";
import {Row, Col, Checkbox} from "react-bootstrap";
import InlineForm from "../FromGroup/InlineForm";
import Component from "../../../components/AscComponent";
import CommonTable from "../Table/CommonTable";
import * as GlobalConst from "../../../components/AscConstants";
import SetDataWithSpeechBubble from "./SetDataWithSpeechBubble";
import * as faIcon from "@fortawesome/free-solid-svg-icons";

/**
 * 権限名入力アイテム
 * state.permission_nameが必要
 */
export class EditPermissionName extends Component {

    render() {
        return (
            <InlineForm
                key = "permission_name"
                controlId = "permission_name"
                label = {this.props.langText.Body.PermissionName}
                type = "text"
                value = {this.props.state.permission_name}
                onChange = {e => this.props.onTextChange_Limit(
                    e, "permission_name",this.props.charaLimit.Permission_permissionName)}
                validationState = {this.props.state.permission_name ? null : "error"} />
        );
    }
}

/**
 * 権限名表示アイテム
 * state.permission_nameが必要
 */
export class ViewPermissionName extends Component {

    render() {
        return (
            <InlineForm
                key="permission_name"
                controlId="permission_name"
                label={this.props.langText.Body.PermissionName}>
                <Col sm={5}>
                    <InlineForm.static
                        key="permission_name"
                        controlId="permission_name">
                        {this.props.state.permission_name}
                    </InlineForm.static>
                </Col>
            </InlineForm>
        )
    }
}

/**
 * ユーザー数表示アイテム
 * state.user_countが必要
 */
export class ViewPermissionUserCount extends Component {
    render() {
        return (
            <InlineForm
                key="user_count"
                controlId="user_count"
                label={this.props.langText.Body.UserCount}>
                <Col sm={5}>
                    <InlineForm.static
                        key="user_count"
                        controlId="user_count">
                        {this.props.state.user_count}
                        <Row className="text-danger fa-pull-right">
                            {this.props.annotation}
                        </Row>
                    </InlineForm.static>
                </Col>
            </InlineForm>
        )
    }
}

/**
 * 権限詳細表示アイテム
 * state[controller_id]が必要
 */
export class ViewPermissionDetail extends Component {

    render() {
        const getPermissionDetailRowClass = (rowInfo) => {
            if (!rowInfo || !rowInfo.original) return "";
            const type = rowInfo.original.__permissionDetailRowType;
            if (!type) return "";
            return `permission-detail-row permission-detail-row--${type}`;
        };

        let modal_columns = [
            {
                Header :this.props.langText.Body.PermissionContent,
                accessor: "SettingColumn_PermissionContent",
            },
            {
                Header :this.props.langText.Body.PermissionScope,
                accessor: "SettingColumn_PermissionScope",
                width: this.props.boardWidth.small,
            },
            {
                Header :this.props.langText.Body.PermissionAll,
                accessor: "SettingColumn_PermissionAll",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionRead,
                accessor: "SettingColumn_PermissionRead",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionCreate,
                accessor: "SettingColumn_PermissionCreate",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionEdit,
                accessor: "SettingColumn_PermissionEdit",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionDelete,
                accessor: "SettingColumn_PermissionDelete",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionExport,
                accessor: "SettingColumn_PermissionExport",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionPlayback,
                accessor: "SettingColumn_PermissionPlayback",
                width: this.props.boardWidth.xxsmall,
            }
        ]
        let returnValue =[];
        const controllerInfos = this.props.state
            && Array.isArray(this.props.state.controllerInfos)
            && this.props.state.controllerInfos.length > 0
                ? this.props.state.controllerInfos
                : null;

        // 画面名取得
        const getLabel = (controller_id) => {
            if (controllerInfos) {
                const info = controllerInfos.find((row) => row.controller_id === controller_id);
                if (info && info.controller_name) {
                    return info.controller_name;
                }
            }
            // 取得できない場合、controller_idを表示(フォールバック処理)
            return controller_id;
        };

        // controllerOrder(controller_id一覧)設定
        const controllerOrder = this.props.state
            && Array.isArray(this.props.state.controllerOrder)
            && this.props.state.controllerOrder.length > 0
                ? this.props.state.controllerOrder
                : [];

        if (controllerInfos) {
            const parents = controllerInfos.filter((row) => row.parent_controller_id === 0);
            parents.forEach((parent) => {
                const parentId = parent.controller_id;
                const parentState = this.props.state[parentId];
                if (!parentState) {
                    return;
                }

                // 子画面（stateが存在するもののみ）
                const children = controllerInfos
                    .filter((row) => row.parent_controller_id === parent.id)
                    .map((child) => ({
                        id: child.controller_id,
                        state: this.props.state[child.controller_id]
                    }))
                    .filter((child) => !!child.state);
                const hasChildren = children.length > 0;
                const parentContent = getLabel(parentId);

                returnValue.push({
                    __permissionDetailRowType: hasChildren ? "parent" : "single",
                    SettingColumn_PermissionContent: parentContent,
                    SettingColumn_PermissionScope:
                        this.props.langText.Body.PermissionScopeList[parentState.scope_code],
                    SettingColumn_PermissionAll: <Checkbox checked={parentState.all} />, 
                    SettingColumn_PermissionRead: <Checkbox checked={parentState.read} />, 
                    SettingColumn_PermissionCreate: <Checkbox checked={parentState.create} />, 
                    SettingColumn_PermissionEdit: <Checkbox checked={parentState.edit} />, 
                    SettingColumn_PermissionDelete: <Checkbox checked={parentState.delete} />, 
                    SettingColumn_PermissionExport: <Checkbox checked={parentState.export} />, 
                    SettingColumn_PermissionPlayback: <Checkbox checked={parentState.playback} />,
                });

                // ViewPermissionDetail は親の閲覧 ON/OFF にかかわらず、子画面行を常に展開表示する
                children.forEach((child) => {
                    returnValue.push({
                        __permissionDetailRowType: "child",
                        SettingColumn_PermissionContent: `┗ ${getLabel(child.id)}`,
                        SettingColumn_PermissionScope:
                            this.props.langText.Body.PermissionScopeList[child.state.scope_code],
                        SettingColumn_PermissionAll: <Checkbox checked={child.state.all} />,
                        SettingColumn_PermissionRead: <Checkbox checked={child.state.read} />,
                        SettingColumn_PermissionCreate: <Checkbox checked={child.state.create} />,
                        SettingColumn_PermissionEdit: <Checkbox checked={child.state.edit} />,
                        SettingColumn_PermissionDelete: <Checkbox checked={child.state.delete} />,
                        SettingColumn_PermissionExport: <Checkbox checked={child.state.export} />,
                        SettingColumn_PermissionPlayback: <Checkbox checked={child.state.playback} />,
                    });
                });
            });
        } else {
            // controllerInfos無効の場合のフォールバック(最低限表示)
            controllerOrder.forEach(row => {
                returnValue.push(
                    {
                        __permissionDetailRowType: "single",
                        SettingColumn_PermissionContent:
                            getLabel(row),
                        SettingColumn_PermissionScope:
                            this.props.langText.Body.PermissionScopeList[this.props.state[row].scope_code],
                        SettingColumn_PermissionAll:
                            <Checkbox checked={this.props.state[row].all} />,
                        SettingColumn_PermissionRead:
                            <Checkbox checked={this.props.state[row].read} />,
                        SettingColumn_PermissionCreate:
                            <Checkbox checked={this.props.state[row].create} />,
                        SettingColumn_PermissionEdit:
                            <Checkbox checked={this.props.state[row].edit} />,
                        SettingColumn_PermissionDelete:
                            <Checkbox checked={this.props.state[row].delete} />,
                        SettingColumn_PermissionExport:
                            <Checkbox checked={this.props.state[row].export} />,
                        SettingColumn_PermissionPlayback:
                            <Checkbox checked={this.props.state[row].playback} />,
                    }
                );
            });
        }
        return (
            <InlineForm
                key = "permission_detail"
                controlId = "permission_detail"
                label = {this.props.langText.Body.permissionDetail}>
                <CommonTable
                    label = {this.props.langText.Body.PermissionName}
                    showPagination = {false}
                    columns = {modal_columns}
                    data = {returnValue}
                    className = {"permission-detail-compact-table"}
                    getTrProps={(state, rowInfo) => ({
                        className: getPermissionDetailRowClass(rowInfo),
                    })}
                    showPaginationBottom = {false}
                    pageSize = {returnValue.length}
                    sortable = {false}
                    style={{height:"400px"}}
                    previousText={this.props.langText.Table.PreviousText}
                    nextText={this.props.langText.Table.NextText}
                    loadingText={this.props.langText.Table.LoadingText}
                    noDataText={this.props.langText.Table.NoDataText}
                    rowsText={this.props.langText.Table.RowsText}
                />
            </InlineForm>
        );
    }
}

/**
 * 権限詳細入力アイテム
 * state[controller_id]が必要
 */
export class EditPermissionDetail extends Component {

    render() {
        const getPermissionDetailRowClass = (rowInfo) => {
            if (!rowInfo || !rowInfo.original) return "";
            const type = rowInfo.original.__permissionDetailRowType;
            if (!type) return "";
            return `permission-detail-row permission-detail-row--${type}`;
        };

        let modal_columns = [
            {
                Header :this.props.langText.Body.PermissionContent,
                accessor: "SettingColumn_PermissionContent",
            },
            {
                Header :this.props.langText.Body.PermissionScope,
                accessor: "SettingColumn_PermissionScope",
                width: this.props.boardWidth.small,
            },
            {
                Header :this.props.langText.Body.PermissionAll,
                accessor: "SettingColumn_PermissionAll",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionRead,
                accessor: "SettingColumn_PermissionRead",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionCreate,
                accessor: "SettingColumn_PermissionCreate",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionEdit,
                accessor: "SettingColumn_PermissionEdit",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionDelete,
                accessor: "SettingColumn_PermissionDelete",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionExport,
                accessor: "SettingColumn_PermissionExport",
                width: this.props.boardWidth.xxsmall,
            },
            {
                Header :this.props.langText.Body.PermissionPlayback,
                accessor: "SettingColumn_PermissionPlayback",
                width: this.props.boardWidth.xxsmall,
            }
        ]
        let scopeList = this.getSelectOption("scope", this.props.langText.SelectOption);
        scopeList = scopeList.filter(item => {
            return GlobalConst.SCOPE_OBJECT[item.value].value
                >= GlobalConst.SCOPE_OBJECT[this.props.currentPermission.scope_code].value;
        });
        let returnValue =[];
        const controllerInfos = this.props.state
            && Array.isArray(this.props.state.controllerInfos)
            && this.props.state.controllerInfos.length > 0
                ? this.props.state.controllerInfos
                : null;

        // 画面名取得
        const getLabel = (controller_id) => {
            if (controllerInfos) {
                const info = controllerInfos.find((row) => row.controller_id === controller_id);
                if (info && info.controller_name) {
                    return info.controller_name;
                }
            }
            // 取得できない場合、controller_idを表示(フォールバック処理)
            return controller_id;
        };

        const pushRow = (controller_id, indent = false) => {
            const state = this.props.state[controller_id];
            if (!state) {
                return;
            }

            // 親行判定（子画面を持つ親画面）
            let currentInfo = null;
            let hasChildren = false;
            if (controllerInfos) {
                currentInfo = controllerInfos.find((row) => row.controller_id === controller_id);
                if (currentInfo && currentInfo.parent_controller_id === 0) {
                    hasChildren = controllerInfos.some(
                        (row) => row.parent_controller_id === currentInfo.id
                    );
                }
            }

            // 親子関係と親のスコープ・閲覧情報取得
            let parentState = null;
            let parentScopeCode = null;
            if (controllerInfos) {
                const rowInfo = controllerInfos.find((row) => row.controller_id === controller_id);
                if (rowInfo && rowInfo.parent_controller_id !== 0) {
                    const parentInfo = controllerInfos.find(
                        (row) => row.id === rowInfo.parent_controller_id
                    );
                    if (parentInfo) {
                        parentState = this.props.state[parentInfo.controller_id];
                        if (parentState) {
                            parentScopeCode = parentState.scope_code;
                        }
                    }
                }
            }

            const isReadOnlyByParent = indent && parentState && !parentState.read;

            const rowType = indent
                ? "child"
                : (hasChildren ? "parent" : "single");

            const label = indent ? `┗ ${getLabel(controller_id)}` : getLabel(controller_id);
            const permissionContent = label;

            // 権限範囲の上限（現在ログイン中ユーザーの権限 / 親画面の権限）を考慮したスコープ候補
            let rowScopeList = scopeList;
            if (parentScopeCode && GlobalConst.SCOPE_OBJECT[parentScopeCode]) {
                rowScopeList = scopeList.filter(item => {
                    return GlobalConst.SCOPE_OBJECT[item.value].value
                        >= GlobalConst.SCOPE_OBJECT[parentScopeCode].value;
                });
            }

            if (
                isReadOnlyByParent ||
                (GlobalConst.SCOPE_OBJECT[state.scope_code].value
                    < GlobalConst.SCOPE_OBJECT[this.props.currentPermission.scope_code].value)
            ) {
                // 操作ユーザー自体の権限範囲が現在設定されている権限範囲より小さい場合、
                // 対象行の権限範囲・全権限チェックボックス操作不可
                returnValue.push({
                    __permissionDetailRowType: rowType,
                    SettingColumn_PermissionContent: permissionContent,
                    SettingColumn_PermissionScope:
                        this.props.langText.Body.PermissionScopeList[state.scope_code],
                    SettingColumn_PermissionAll: <Checkbox checked={state.all} />,
                    SettingColumn_PermissionRead: <Checkbox checked={state.read} />,
                    SettingColumn_PermissionCreate: <Checkbox checked={state.create} />,
                    SettingColumn_PermissionEdit: <Checkbox checked={state.edit} />,
                    SettingColumn_PermissionDelete: <Checkbox checked={state.delete} />,
                    SettingColumn_PermissionExport: <Checkbox checked={state.export} />,
                    SettingColumn_PermissionPlayback: <Checkbox checked={state.playback} />,
                });
            } else {
                returnValue.push({
                    __permissionDetailRowType: rowType,
                    SettingColumn_PermissionContent: permissionContent,
                    SettingColumn_PermissionScope:
                        <select
                            value={state.scope_code}
                            onChange={e => this.props.onNestSetState(e, controller_id, "scope_code")}>
                            {rowScopeList.map(scope_row =>
                                <option value={scope_row.value}>{scope_row.label}</option>)}
                        </select>,
                    SettingColumn_PermissionAll:
                        <Checkbox
                            checked={state.all}
                            onChange={e => this.props.onNestCheckBoxChange(e, controller_id, "all")} />,
                    SettingColumn_PermissionRead:
                        <Checkbox
                            checked={state.read}
                            onChange={e => this.props.onNestCheckBoxChange(e, controller_id, "read")} />,
                    SettingColumn_PermissionCreate:
                        <Checkbox
                            checked={state.create}
                            onChange={e => this.props.onNestCheckBoxChange(e, controller_id, "create")} />,
                    SettingColumn_PermissionEdit:
                        <Checkbox
                            checked={state.edit}
                            onChange={e => this.props.onNestCheckBoxChange(e, controller_id, "edit")} />,
                    SettingColumn_PermissionDelete:
                        <Checkbox
                            checked={state.delete}
                            onChange={e => this.props.onNestCheckBoxChange(e, controller_id, "delete")} />,
                    SettingColumn_PermissionExport:
                        <Checkbox
                            checked={state.export}
                            onChange={e => this.props.onNestCheckBoxChange(e, controller_id, "export")} />,
                    SettingColumn_PermissionPlayback:
                        <Checkbox
                            checked={state.playback}
                            onChange={e => this.props.onNestCheckBoxChange(e, controller_id, "playback")} />,
                });
            }
        };

        const controllerOrder = this.props.state
            && Array.isArray(this.props.state.controllerOrder)
            && this.props.state.controllerOrder.length > 0
                ? this.props.state.controllerOrder
                : [];

        if (controllerInfos) {
            const parents = controllerInfos.filter((row) => row.parent_controller_id === 0);
            parents.forEach((parent) => {
                const parentId = parent.controller_id;
                pushRow(parentId, false);

                const children = controllerInfos.filter((row) => row.parent_controller_id === parent.id);
                if (children.length === 0) {
                    return;
                }

                children.forEach((child) => {
                    pushRow(child.controller_id, true);
                });
            });
        } else {
            // controllerInfos無効の場合のフォールバック(最低限表示)
            controllerOrder.forEach(row => {
                pushRow(row, false);
            });
        }
        return (
            <InlineForm
                key = "permission_detail"
                controlId = "permission_detail"
                label = {(
                    <SetDataWithSpeechBubble
                        displayData = {this.props.langText.Body.permissionDetail}
                        speechBubbleData = {this.props.langText.Body.permissionDetailExp}
                        custom = "speech-bubble-permission-detail-help"
                        infoIconDisplayFlag = {true}
                        infoIconType = {faIcon.faInfoCircle}
                        infoIconClassName = "modal-info-icon"
                        infoIconColor = "silver"
                        infoIconSize = "lg"/>
                )}>
                <CommonTable
                    label={this.props.langText.Body.PermissionName}
                    showPagination={false}
                    columns={modal_columns}
                    data={returnValue}
                    className={"permission-detail-compact-table"}
                    getTrProps={(state, rowInfo) => ({
                        className: getPermissionDetailRowClass(rowInfo),
                    })}
                    showPaginationBottom={false}
                    pageSize={returnValue.length}
                    sortable={false}
                    style={{height: "400px"}}
                    previousText={this.props.langText.Table.PreviousText}
                    nextText={this.props.langText.Table.NextText}
                    loadingText={this.props.langText.Table.LoadingText}
                    noDataText={this.props.langText.Table.NoDataText}
                    rowsText={this.props.langText.Table.RowsText}
                />
            </InlineForm>
        );
    }
}
